<template>
    <noscript></noscript>
</template>

<script>
    import { bus } from '../../main'

    export default {
        name: 'Google',
        data() {
            return {
                loaded: false
            }
        },
        computed: {
            id: function () {
                return process.env.VUE_APP_GOOGLE;
            },
            debug: function () {
                return process.env.VUE_APP_GOOGLE_DEBUG !== 'false';
            }
        },
        mounted() {
            const self = this;

            let googleAnalyticsScript = document.createElement('script');
            googleAnalyticsScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + this.id);
            document.head.appendChild(googleAnalyticsScript);

            googleAnalyticsScript.onload = function() {
                self.$store.commit('setAnalyticsLoaded', 'google');
                self.loaded = true;
            };

            window.gtag = function () { window.dataLayer.push(arguments); };
            window.dataLayer = window.dataLayer || [];

            setTimeout(function () {
                if (!self.loaded) {
                    self.$store.commit('setAnalyticsLoaded', 'google');
                }
            }, 1500);

            bus.$on('laboratoryLanding.analytics', (data) => {
                if (!self.loaded) {
                    return;
                }

                let action;
                switch (data.action) {
                    case '20sec':
                        action = 'ViewContent';
                        break;
                    case 'loadAttachments':
                        action = 'InitiateCheckout';
                        break;
                }

                if (!action) {
                    return;
                }

                const params = {};
                if (self.$store.state.analyticsLandingParameter) {
                    params.service = self.$store.state.analyticsLandingParameter;
                }

                if (!self.debug) {
                    window.gtag('event', action, params);
                }

                console.debug('google send event:', action, params, self.debug);
            });
        }
    }
</script>
